import React from 'react'
import Fab from '@mui/material/Fab'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import AddIcon from '@mui/icons-material/Add'
import ConditionsList from './conditionsList'
import { useDispatch } from 'react-redux'
import { addedWhereConditionAction } from '../../store/pages/common/query'

export default function Conditions () {
  const dispatch = useDispatch()

  const title = 'Filters'

  return (
    <Box display="flex" justifyContent="space-between" flexDirection="column" gap={2}>
      <Box display="flex" alignItems="center">
        <Typography width="50%" textAlign="left" variant="h6">{title}</Typography>
        <Fab
          size="small"
          color="primary"
          aria-label="add"
          justifySelf="center"
          onClick={() => dispatch(addedWhereConditionAction)}
        >
            <AddIcon />
        </Fab>
      </Box>

      <Box>
        <ConditionsList />
      </Box>
    </Box>
  )
}
